<template>
  <div class="alarm_info_container">
    <div class="filter_container" style="margin-bottom:10px">
      <div>
        <!-- <el-button style="margin-right:10px" type='primary' size="small" @click="selectAll">全选</el-button> -->
        <!-- <el-button style="margin-right:10px" type='primary' size="small" @click="selectNone">反选</el-button> -->
        <el-button style="margin-right:10px" type="primary" size="small" @click="updateStatus">标记已读</el-button>
        <el-button
          @click="searchData('0')"
          style="margin-right:10px"
          type="primary"
          size="small"
        >显示未读</el-button>
        <el-button
          @click="searchData('1')"
          style="margin-right:10px"
          type="primary"
          size="small"
        >显示已读</el-button>
        <el-button
          @click="searchData('')"
          style="margin-right:10px"
          type="primary"
          size="small"
        >显示全部</el-button>
      </div>
    </div>
    <div class="section-list marginAuto">
      <el-table
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
        style="width: 100%"
        :header-cell-style="{background:'#6baf6f',color:'#fff'}"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
        <el-table-column prop="title" label="任务名称" width="170" align="center"></el-table-column>
        <el-table-column prop="registerTime" label="时间" width="170" align="center"></el-table-column>
        <el-table-column prop="content" label="信息" align="center"></el-table-column>
        <el-table-column prop="stateName" label="状态" align="center" width="80"></el-table-column>
      </el-table>

      <!-- <table align="center" cellspacing="0" cellpadding="0" class="table_title table_green_title">
        <thead>
          <tr>
            <th>序号</th>
            <th>任务名称</th>
            <th>时间</th>
            <th>信息</th>
            <th>状态</th>
          </tr>
        </thead>
      </table>
      <table align="center" cellspacing="0" cellpadding="0" class="table_content table_green">
        <tbody>
          <tr v-for="(item, index) in tableData" :key="item.id">
            <td>{{ (pagination.pageNum - 1) * 10 + (index + 1) }}</td>
            <td>{{item.title}}</td>
            <td>{{ item.registerTime }}</td>
            <td>{{item.content}}</td>
            <td>{{item.stateName}}</td>


          </tr>
        </tbody>
      </table>-->
      <el-pagination
        class="tab_pagination"
        background
        :pageSize="pagination.pageSize"
        layout="prev, pager, next"
        @current-change="currentChange"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { color } from "echarts";
import { selectNoticePage, updateNoticeState } from "../../utils/api/AlarmInfo";
export default {
  name: "AlarmInfo",
  data() {
    return {
      pagination: {
        // 列表分页默认数据
        total: 10,
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
      state: "", //1已读 0未读
      ids: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    handleSelectionChange(data) {
      this.ids = data.map(res => res.id);
    },
    currentChange(value) {
      this.pagination.pageNum = value;
      this.getData();
    },
    updateStatus() {
      if (!this.ids.length) {
        this.$message({
          message: "请选择数据!",
          type: "error"
        });
        return;
      }

      updateNoticeState(this.ids)
        .then(res => {
          debugger
          this.$message({
            message: "操作成功！",
            type: "success"
          });
          this.getData();
        })
        .catch(res => {});
    },
    searchData(data) {
      this.state = data;
      this.pagination.pageNum = 1;
      this.getData();
    },
    async getData() {
      this.loading = true;
      const res = await selectNoticePage({
        currentPage: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        deptId: 5, //this.deptId,
        state: this.state
      });
      this.pagination.total = res.data.data.total;
      this.tableData = res.data.data.records.map(res => {
        if (res.state === 1) {
          res.stateName = "已读";
        } else if (res.state === 0) {
          res.stateName = "未读";
        }
        return res;
      });
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.alarm_info_container {
  margin-left: 30px;
  width: calc(100% - 200px);
}
.filter_container {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>